import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaTrashAlt } from "react-icons/fa";
import useSortableData from "../../utils/SortData";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { TablerCaretUpDownFilled } from "../../assets/icons/LayoutIcon";
import { CircleMinus, CirclePlus, Minus, Plus } from "lucide-react";
import { FaChevronDown } from "react-icons/fa6";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { COMPANIES, CompaniesWithValue } from "../../constants/fetchData";
import { getDistributorNames, getUser } from "../../Common/functions";
import { RetrieveItemGroups } from "../../services/applicationReport";
import TableSearchableDropdown from "../Layout/TableSearchableDropdown";
// import TableSearchableDropdown from "./TableSearchableDropdown"; // Import the searchable dropdown

const defaultRow = {
  product_group: "",
  product_name: "",
  unit_price: "",
  quantity: 0,
};

const isRowComplete = (row) => {
  return (
    row.product_group.trim() !== "" &&
    row.product_name.trim() !== "" &&
    row.unit_price.trim() !== "" &&
    parseInt(row.quantity) > 0
  );
};

const isRowEmpty = (row) => {
  return (
    !row.product_group &&
    !row.product_name &&
    !row.unit_price &&
    row.quantity === 0
  );
};

const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
// const user = JSON.parse(localStorage.getItem("user"));
const user = getUser();
console.log("user", user);

const NewEntrySection = ({ handleBack, userRole }) => {
  const [rows, setRows] = useState([{ ...defaultRow }]);
  const [customerName, setCustomerName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [showWarning, setShowWarning] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Get distributor name and user info (you'll need to define these)
  const distributorName = getDistributorNames()[0] || "Default Distributor";
  const userNm = user?.name || "Default User";

  const [emailList, setEmailList] = useState([]);

  // Add this new function after the existing helper functions

  const getEmailList = async (distributorName) => {
    try {
      let matchingRecords = [];

      // Function to handle response and find matching records
      const handleResponse = (response) => {
        // Parse the body field which contains the JSON string
        let datajsons;
        try {
          datajsons = JSON.parse(response.body);
        } catch (parseError) {
          return;
        }

        // Check if datajsons is an array
        if (!Array.isArray(datajsons)) {
          return;
        }

        // Iterate through the datajsons array and find matching records
        datajsons.forEach((record) => {
          // Check if distributor_name array includes the distributorName
          if (
            Array.isArray(record.distributor_name) &&
            record.distributor_name.some(
              (name) =>
                name.toLowerCase().includes(distributorName.toLowerCase()) ||
                distributorName.toLowerCase().includes(name.toLowerCase())
            )
          ) {
            matchingRecords.push(record);
          }
        });
      };

      // First API request - manager-profile
      try {
        const response1 = await fetch(
          `https://xqaizmksl2.execute-api.us-west-2.amazonaws.com/test/Get_user_profile?category=manager-profile`
        );
        const data1 = await response1.json();
        handleResponse(data1);
      } catch (error) {
        console.log("Error fetching manager-profile:", error);
      }

      // Second API request - Internal-user-profile
      try {
        const response2 = await fetch(
          `https://xqaizmksl2.execute-api.us-west-2.amazonaws.com/test/Get_user_profile?category=Internal-user-profile`
        );
        const data2 = await response2.json();
        handleResponse(data2);
      } catch (error) {
        console.log("Error fetching Internal-user-profile:", error);
      }

      // Extract all emails from matching records
      const emailList = matchingRecords
        .map((record) => record.email)
        .filter((email) => email);
      return emailList;
    } catch (error) {
      console.log("Error in getEmailList:", error);
      return [];
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      const distributorName = getDistributorNames()[0];
      setCustomerName(distributorName);

      // Fetch email list using the new function
      if (distributorName) {
        const emails = await getEmailList(distributorName);
        setEmailList(emails);
        console.log("userNm", userNm, "emailList", emails);
      }
    };

    initializeData();
  }, []);

  useEffect(() => {
    // if (isAuthenticated && user) {
    setCustomerName(getDistributorNames()[0]);
    // }
  }, []);

  const [productGroupList, setProductGroupList] = useState([]);

  const getProductGroup = async () => {
    let result = [];
    result = await RetrieveItemGroups(1747653662341);
    const groups = result?.data?.text?.itemgroups || [];
    setProductGroupList(groups);
    console.log(result?.data?.text?.itemgroups);
  };

  useEffect(() => {
    getProductGroup();
  }, []);

  // Consolidate line items logic from jQuery
  const consolidateLineItems = (validRows) => {
    const consolidatedItems = {};

    validRows.forEach((row) => {
      const group = productGroupList.find(
        (g) => g.group_id === row.product_group
      );
      const product = group?.items?.find(
        (item) => item.name === row.product_name
      );

      if (product) {
        const itemId = product.item_id;
        const quantity = parseInt(row.quantity);

        if (consolidatedItems.hasOwnProperty(itemId)) {
          // If item_id already exists, increment quantity
          consolidatedItems[itemId].quantity += quantity;
        } else {
          // If item_id does not exist, add new entry
          consolidatedItems[itemId] = {
            quantity: quantity,
            item_id: itemId,
            product_name: group.group_name,
            name: row.product_name,
            checkbox: "on",
            description: "",
            unit: "qty",
          };
        }
      }
    });

    // Convert consolidatedItems object to array
    const consolidatedArray = [];
    for (let itemId in consolidatedItems) {
      if (consolidatedItems.hasOwnProperty(itemId)) {
        consolidatedArray.push(consolidatedItems[itemId]);
      }
    }

    return consolidatedArray;
  };

  // API call functions
  const createInventorySalesOrder = async (data) => {
    const response = await fetch(
      "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod/sales_tracking/Create_inventory_sales_order",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  };

  const createCRMRecord = async (data) => {
    const response = await fetch(
      "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod/Zoho_CRM_custom_module_create_records",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: [data] }),
      }
    );
    return await response.json();
  };

  const createDistributorSale = async (data) => {
    const response = await fetch(
      "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod/sales_tracking_distributorsales_post",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  };

  const sendEmail = async (emailData) => {
    const response = await fetch(
      "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod/send_mail_po",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      }
    );
    return await response.json();
  };

  const handleInputChange = (index, key, value) => {
    const updatedRows = [...rows];
    updatedRows[index][key] = value;

    // Reset dependent fields when product group changes
    if (key === "product_group") {
      updatedRows[index].product_name = "";
      updatedRows[index].unit_price = "";
    }

    if (key === "product_name") {
      const group = productGroupList.find(
        (g) => g.group_id === updatedRows[index].product_group
      );
      const product = group?.items?.find((item) => item.name === value);
      if (product) {
        updatedRows[index].unit_price = product.rate.toString();
      }
    }

    // Auto-add new row if last one is filled
    if (index === updatedRows.length - 1 && isRowComplete(updatedRows[index])) {
      updatedRows.push({ ...defaultRow });
    }

    setRows(updatedRows);
  };

  const handleAddRow = (index) => {
    if (isRowComplete(rows[index])) {
      const updatedRows = [...rows];
      updatedRows.splice(index + 1, 0, { ...defaultRow });
      setRows(updatedRows);
    } else {
      toast.error("Please fill out the current row before adding a new one.");
    }
  };

  const handleRemoveRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows.length ? updatedRows : [{ ...defaultRow }]);
  };

  const handleSubmit = async () => {
    try {
      // Check click timing (15 second restriction)
      const currentTime = Date.now();
      if (currentTime - lastClickTime < 15000) {
        console.log("Please wait for few seconds before clicking again.");
        setShowWarning(true);
        setTimeout(() => setShowWarning(false), 3000);
        return;
      }
      setLastClickTime(currentTime);

      // Validate rows
      const validRows = rows.filter(
        (row) => !isRowEmpty(row) && isRowComplete(row)
      );

      if (validRows.length === 0) {
        toast.error(
          "No data found. Please fill out the form before submitting."
        );
        return;
      }

      setIsSubmitting(true);

      // Consolidate line items
      const consolidatedLineItems = consolidateLineItems(validRows);
      console.log("Consolidated Items:", consolidatedLineItems);

      // Prepare main data object
      const mainData = {
        customer_id: CompaniesWithValue.find(
          (item) => item.label === customerName
        )?.value, // You might need to get the actual ID
        notes: "Sample Note",
        terms: "Terms and Conditions",
        discount: "0%",
        is_discount_before_tax: "false",
        discount_type: "entity_level",
        distributor_name: customerName,
        shipping_charge: 0,
        delivery_method: "FedEx",
        place_of_supply: "TN",
        category: "Sales Order",
        customer_name: customerName,
        line_items: consolidatedLineItems,
      };

      console.log("Main Data:", mainData);

      // Step 1: Create inventory sales order
      const salesOrderResponse = await createInventorySalesOrder(mainData);
      console.log("Sales Order Response:", salesOrderResponse);

      if (
        salesOrderResponse.status_code === 201 ||
        salesOrderResponse.status_code === 200
      ) {
        //   const responseBody = JSON.parse(salesOrderResponse.body);
        //   const salesOrderData = JSON.parse(responseBody.text).salesorder;
        const parsedText = JSON.parse(salesOrderResponse.text); // parse the JSON string
        const salesOrderData = parsedText.salesorder;

        // Update main data with response values
        mainData.salesorder_number = salesOrderData.salesorder_number;
        mainData.total_quantity = salesOrderData.total_quantity;
        mainData.amount = salesOrderData.total;
        mainData.dates = salesOrderData.date;
        mainData.created_date = salesOrderData.created_date;
        mainData.salesorder_id = salesOrderData.salesorder_id;
        mainData.Name = salesOrderData.salesorder_number;
        mainData.order_status = "Submitted";

        console.log("Updated Main Data:", mainData);

        // Modify line items for CRM
        mainData.line_items.forEach((item) => {
          item.name1 = item.name;
          delete item.name;
        });

        // Step 2: Create CRM record
        try {
          const crmResponse = await createCRMRecord(mainData);
          console.log("CRM Response:", crmResponse);
        } catch (crmError) {
          console.log("CRM Error:", crmError);
        }

        // Step 3: Create distributor sale
        try {
          const distributorSaleResponse = await createDistributorSale(mainData);
          console.log("Distributor Sale Response:", distributorSaleResponse);

          // Step 4: Send email
          const currentDate = new Date().toISOString().slice(0, 10);
          const emailData = {
            purchase_order: {
              order_id: mainData.salesorder_number,
              customer_name: customerName,
              order_date: currentDate,
              Crate_user: userNm,
              Amount: mainData.amount,
              recipient_emails: emailList,
            },
          };

          console.log("Email Data:", emailData);

          try {
            const emailResponse = await sendEmail(emailData);
            console.log("Email Response:", emailResponse);

            // Success - show success message and redirect
            setShowSuccess(true);
            // setTimeout(() => {
            //   setShowSuccess(false);
            //   // Navigate to sales order report
            //   window.location.href = "Sales-order-report.html";
            // }, 3000);
          } catch (emailError) {
            console.log("Email Error:", emailError);
            // Still redirect even if email fails
            // window.location.href = "Sales-order-report.html";
          }
        } catch (distributorError) {
          console.log("Distributor Sale Error:", distributorError);
        }
      } else {
        // Handle other status codes
        // setShowSuccess(true);
        // setTimeout(() => {
        //   setShowSuccess(false);
        //   window.location.href = "Sales-order-report.html";
        // }, 3000);
      }
    } catch (error) {
      console.log("Submit Error:", error);
      toast.error("An error occurred while submitting the order.");
    } finally {
      setIsSubmitting(false);
      handleBack();
    }
  };

  const tableHeaders = [
    { label: "Add/Remove", value: "action" },
    { label: "Product Group", value: "product_group" },
    { label: "Product name", value: "product_name" },
    { label: "Unit Price", value: "unit_price" },
    { label: "Quantity", value: "quantity" },
  ];

  const { sortedItems, handleSort } = useSortableData(rows);

  const incrementQuantity = (index) => {
    const updated = [...rows];
    const currentValue = parseInt(updated[index].quantity) || 0;
    updated[index].quantity = currentValue + 1;
    setRows(updated);
  };

  const decrementQuantity = (index) => {
    const updated = [...rows];
    const currentValue = parseInt(updated[index].quantity) || 0;
    updated[index].quantity = Math.max(0, currentValue - 1);
    setRows(updated);
  };

  const customers = COMPANIES;

  return (
    <div className="px-4">
      <style>
        {`
          @media (max-width: 640px) {
            .mobile-table tr {
              display: flex;
              flex-direction: column;
              border: 1px solid #e5e7eb;
              margin-bottom: 2rem;
              padding: 0.5rem;
              border-radius: 0.375rem;
            }
            .mobile-table td {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0.75rem 0; /* Reduced padding-y */
              border-bottom: 1px solid #e5e7eb;
            }
            .mobile-table td:last-child {
              border-bottom: none;
            }
            .mobile-table td::before {
              flex: 0 0 40%;
              font-weight: 600;
              margin-right: 1rem;
              color: #374151;
            }
            .mobile-table td > * {
              flex: 1;
              text-align: left;
            }
            .mobile-table td input,
            .mobile-table td select,
            .mobile-table td .primary-dropdown {
              width: 100%;
              max-width: 100%;
            }
             .mobile-table td .quantity-controls {
              max-width: 100px;
              gap: 0.25rem;
            }
          }
        `}
      </style>
      {/* Warning Alert */}
      {showWarning && (
        <div className="fixed top-4 right-4 bg-yellow-500 text-white px-4 py-2 rounded-md shadow-lg z-50">
          Please wait for few seconds before clicking again.
        </div>
      )}

      {/* Success Alert */}
      {showSuccess && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg z-50">
          Order submitted successfully!
        </div>
      )}

      <div className="flex justify-between items-center gap-6">
        <div className="flex justify-start items-center gap-2">
          <button onClick={handleBack}>
            <FaChevronLeft className="text-text1 w-5 h-5" />
          </button>
          <h1 className="text-3xl font-bold text-text1">Cart</h1>
        </div>
        <button
          onClick={handleSubmit}
          disabled={isSubmitting}
          className={`text-white text-sm px-3 py-2 rounded-md ${
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-primary hover:bg-primary-dark"
          }`}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </div>

      <hr className="mt-6" />

      <div className="mt-10">
        <div>
          <div className="flex-1  md:w-2/5 w-fit">
            <label className="font-medium text-sm leading-5 text-text2">
              Customer Name
            </label>
            <div className="primary-dropdown mt-1">
              <select
                name="customerName"
                className="rounded px-1 text-sm font-normal text-text1 uppercase focus:outline-none focus:ring-0 w-full"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                disabled={!(userRole === "super_admin")}
              >
                {!(userRole === "super_admin") ? (
                  // <option value="">Select Name</option>
                  <option value={customerName}>{customerName}</option>
                ) : (
                  customers.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))
                )}
              </select>
            </div>
          </div>
        </div>
        <div className="rounded-lg sm:border border-gray-300 overflow-x-auto my-10">
          <Table className="w-full border-gray-300 rounded-lg mobile-table">
            <Thead className="bg-gray-100 sm:border-b rounded-lg">
              <Tr>
                {tableHeaders.map((header, index) => (
                  <Th
                    key={index}
                    className="px-4 py-3 text-left font-semibold text-xs text-text1"
                  >
                    {header.value !== "action" ? (
                      <div
                        className="flex items-center gap-1 cursor-pointer"
                        onClick={() => handleSort(header.value)}
                      >
                        <TablerCaretUpDownFilled className="hidden sm:block" />
                        <span>{header.label}</span>
                      </div>
                    ) : (
                      <span>{header.label}</span>
                    )}
                  </Th>
                ))}
              </Tr>
            </Thead>

            <Tbody>
              {sortedItems.map((item, index) => (
                <Tr key={index} className="border-t">
                  <Td className="px-4 py-4 text-xs text-text2">
                    {index === rows.length - 1 ? (
                      <button
                        onClick={() => handleAddRow(index)}
                        className="flex items-center justify-center w-10 h-10"
                      >
                        <CirclePlus className="text-gray-600" />
                      </button>
                    ) : (
                      <button
                        onClick={() => handleRemoveRow(index)}
                        className="flex items-center justify-center w-10 h-10"
                      >
                        <CircleMinus className="text-gray-400" />
                      </button>
                    )}
                  </Td>

                  {/* Product Group - Now Searchable */}
                  <Td className="px-3 py-4 text-xs text-text2">
                    <TableSearchableDropdown
                      options={productGroupList}
                      value={item.product_group}
                      onChange={handleInputChange}
                      name="product_group"
                      placeholder="Select"
                      searchPlaceholder="Search product groups..."
                      optionKey="group_id"
                      optionLabel="group_name"
                      noOptionsMessage="No product groups found"
                      index={index}
                    />
                  </Td>

                  {/* Product Name - Now Searchable */}
                  <Td className="px-3 py-4 text-xs text-text2">
                    <TableSearchableDropdown
                      options={
                        productGroupList.find(
                          (g) => g.group_id === item.product_group
                        )?.items || []
                      }
                      value={item.product_name}
                      onChange={handleInputChange}
                      name="product_name"
                      placeholder="Select"
                      searchPlaceholder="Search products..."
                      optionKey="name"
                      optionLabel="name"
                      noOptionsMessage="No products found"
                      disabled={!item.product_group}
                      index={index}
                    />
                  </Td>

                  <Td className="px-3 py-4 text-xs text-text2 ">
                    <input
                      type="text"
                      value={item.unit_price}
                      readOnly
                      className="border-gray-300 rounded px-3 py-4 text-xs w-full focus:outline-none"
                      placeholder="0"
                    />
                  </Td>
                  <Td className="px-3 py-4 text-xs text-text2">
                    <div className="flex items-center gap-0.5 quantity-controls">
                      <button
                        onClick={() => decrementQuantity(index)}
                        className="border-gray-300 rounded-l p-1 w-8 flex justify-center"
                      >
                        <Minus size={16} strokeWidth={2} />
                      </button>
                      <input
                        type="text"
                        value={item.quantity}
                        onChange={(e) =>
                          handleInputChange(index, "quantity", e.target.value)
                        }
                        className="border-gray-300 py-4 px-1 text-center w-10 text-xs"
                      />

                      <button
                        onClick={() => incrementQuantity(index)}
                        className="border-gray-300 rounded-r p-1 w-8 flex justify-center"
                      >
                        <Plus size={16} strokeWidth={2} />
                      </button>
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default NewEntrySection;
